import Index from './Index.svelte';
const app = new Index({
    target: document.body,
    props: {}
});
export default app;
